import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import {
    IonApp,
    IonIcon,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonAlert,
    IonLabel,
    isPlatform
} from '@ionic/react';
import {setupConfig} from '@ionic/core';
import { IonReactRouter } from '@ionic/react-router';
import { list, notificationsOutline, search, settings, archive, albums, folder, paperPlane, wallet, school, newspaper, searchCircleSharp, pieChart, searchCircle, medal, ribbon, book, library, layers, rocket, trophy, helpBuoy, globe, earth, statsChart } from 'ionicons/icons';
import Queue from './pages/Queue.js';
import Studysets from './pages/Studysets.js';
import Studyset from './pages/Studyset.js';
import Practice from './pages/Practice.js';
import Flashcards from './pages/Flashcards.js';
import Terms from './pages/Terms.js';
import Subscription from './pages/Subscription.js'
import DropboxOwn from './Dropbox.js'
import SQLStorage from './SQLStorage.js'
import HelpGuides from './pages/HelpGuides.js';
import DropboxInit from './pages/DropboxInit.js';
import HelpGuide from './pages/HelpGuide.js';
import Discover from './pages/Discover.js';
import Settings from './pages/Settings.js';
import Statistics from './pages/Statistics';
import Import from './pages/Import.js';
import AllSets from './pages/AllSets.js';
import axios from 'axios';
import { TextToSpeech } from '@capacitor-community/text-to-speech';

import enLang from './languages/en';
import huLang from './languages/hu';
import esLang from './languages/es';
import ptLang from './languages/pt';
import daLang from './languages/da';
import deLang from './languages/de';
import etLang from './languages/et';
import fiLang from './languages/fi';
import frLang from './languages/fr';
import itLang from './languages/it';
import nlLang from './languages/nl';
import noLang from './languages/no';
import plLang from './languages/pl';
import roLang from './languages/ro';
import skLang from './languages/sk';
import slLang from './languages/sl';
import svLang from './languages/sv';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import './styles/App.scss';
import './styles/DarkMode.scss';
import './styles/Web.scss';

import store from './state/store';
import { connect, dispatch } from 'react-redux';
import { updateSets } from './state/actions/Calendar'
import { updateURL } from './state/actions/URL';
import { updatedSetsSet, clearUpdatedSetsSet } from './state/actions/UpdatedSets';
import Dexie from 'dexie';

/* Theme variables */
import './theme/variables.css';
import Storage from './Storage';
import Utilities from './Utilities';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UnsupportedBrowser from './pages/UnsupportedBrowser.js';

import TrendingBase from './trendingBase.json';
import Server from './Server.js';

import { SplashScreen } from '@capacitor/splash-screen';
import { Device } from '@capacitor/device';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Keyboard } from '@capacitor/keyboard';
import { App } from '@capacitor/app';

interface State {
    showTabs: boolean;
}

interface Props {

}

// console.log = function nope() {}
// console.error = function nope() {}
// console.warn = function nope() {}

// REMOVE ON PHONE
// setupConfig({ mode: 'ios', animated: false });

// TO DO REMOVE At the end of the year
const PRC = {
    "J4YLA0": new Date(2022, 3, 1),
    "10DJ2I": new Date(2022, 4, 1),
    "CX83T4": new Date(2022, 5, 1),
    "BSDF3P": new Date(2022, 6, 1),
    "H1TOZH": new Date(2022, 7, 1),
    "GP075B": new Date(2022, 8, 1),
    "19DO7D": new Date(2022, 9, 1),
    "E3GPYO": new Date(2022, 10, 1),
    "9L72AL": new Date(2022, 11, 1),
    "48W21X": new Date(2023, 0, 1),
    "2P0Z2T": new Date(2023, 1, 1),
    "0H2UBU": new Date(2023, 2, 1),
    "N4W29T": new Date(2023, 3, 1),
}

class AppMain extends React.Component<Props, State> {

    constructor(props) {
        super(props);
        this.state = {
            currentUrl: window.location.pathname,
            showSubscriptionModal: false
        }
        let el = document.getElementsByTagName("body");
        if (el && el[0]) el[0].setAttribute("data-page", window.location.pathname)
        window.LANGUAGES = {
            'en': "English",
            'hu': "Magyar",
            'es': "Español",
            'pt': "Portuguese",
            'da': "Danish",
            'nl': "Dutch",
            'et': "Estonian",
            'fi': "Finnish",
            'fr': "French",
            'de': "German",
            'it': "Italian",
            'no': "Norwegian",
            'pl': "Polish",
            'ro': "Romanian",
            'sk': "Slovak",
            // 'sl': "Slovenian",
            // 'sv': "Swedish"
        }
        window.domainPathAuth = "https://simplecards.app/"
        window.dropbox = new DropboxOwn();
        window.ln = enLang;
        window.cachedImages = localStorage.getItem("cachedImages") ? JSON.parse(localStorage.getItem("cachedImages")) : [];
        window.globalVars = {
            AVAILABLE_FLAGS: ["it", "ad","cm","ge","kw","nr","sx","ae","cn","gf","ky","nu","sy","af","co","gg","kz","nz","sz","ag","cr","gh","la","om","tc","ai","cu","gi","lb","pa","td","al","cv","gl","lc","pe","tf","am","cw","gm","li","pf","tg","ao","cx","gn","lk","pg","th","aq","cy","gp","lr","ph","tibet","ar","cz","gq","ls","pk","tj","as","de","gr","lt","pl","tk","at","dj","gs","lu","pm","tl","au","dk","gt","lv","pn","tm","aw","dm","gu","ly","pr","tn","ax","do","gw","ma","ps","to","az","dz","gy","malayali","pt-20","tr","ba","easter_island","hausa","maori","pt-30","transnistria","bb","ec-w","hk","mc","pt","tt","bd","ec","hm","md","pw","tv","be","ee","hmong","me","py","tw","bf","eg","hn","mf","qa","tz","bg","eh","hr","mg","re","ua","bh","er","ht","mh","ro","ug","bi","es-ce","hu","mk","rs","um","bj","es-cn","id","ml","ru","united_nations","bl","es-ga","ie","mm","rw","us-hi","bm","es-ib","il","mn","sa","us","bn","es-ml","im","mo","sb","uy","bo","es-pv","in","mp","sc","uz","bq-bo","es-variant","io","mq","sd","va","bq-sa","es","iq","mr","se","vc","bq-se","esperanto","ir","ms","sg","ve","bq","et","is","mt","sh-ac","vg","br","european_union","it-82","mu","sh-hl","vi","bs","fi","it-88","mv","sh-ta","vn","bt","fictionit","mw","sh","vu","bv","fj","je","mx","si","wf","bw","fk","jm","my","sindh","ws","by","fm","jo","mz","sj","xk","bz","fo","jp","na","sk","xx","ca-bc","fr-h","kannada","nato","sl","ye","ca","fr","ke","nc","sm","yiddish","cc","ga","kg","ne","sn","yt","cd","gb-eng","kh","nf","so","za","cf","gb-ork","ki","ng","somaliland","zm","cg","gb-sct","km","ni","south_ossetia","zw","ch","gb-wls","kn","nl","sr","ci","gb","kp","no","ss","ck","gd","kr","northern_cyprus","st","cl","ge-ab","kurdistan","np","sv"],
            LANGUAGES_CODES_TO_COUNTRY: {
                'en': { color: '#875775', logo: 'gb'},
                'ca': { color: '#454545', logo: 'ad'},
                'fa': { color: '#454545', logo: 'af'},
                'sq': { color: '#454545', logo: 'al'},
                'hy': { color: '#454545', logo: 'am'},
                'sv': { color: '#454545', logo: 'ax'},
                'az': { color: '#454545', logo: 'az'},
                'bs': { color: '#454545', logo: 'ba'},
                'bn': { color: '#454545', logo: 'bd'},
                'bg': { color: '#454545', logo: 'bg'},
                'ms': { color: '#454545', logo: 'bn'},
                'es': { color: '#ba602f', logo: 'es'},
                'pt': { color: '#688641', logo: 'br'},
                'dz': { color: '#454545', logo: 'bt'},
                'no': { color: '#454545', logo: 'bv'},
                'be': { color: '#454545', logo: 'by'},
                'zh-hans': { color: '#454545', logo: 'cn'},
                'cs': { color: '#865675', logo: 'cz'},
                'de': { color: '#8e3c27', logo: 'de'},
                'da': { color: '#454545', logo: 'dk'},
                'et': { color: '#454545', logo: 'ee'},
                'ti': { color: '#454545', logo: 'er'},
                'am': { color: '#454545', logo: 'et'},
                'fi': { color: '#454545', logo: 'fi'},
                'fo': { color: '#454545', logo: 'fo'},
                'fr': { color: '#816382', logo: 'fr'},
                'ka': { color: '#454545', logo: 'ge'},
                'kl': { color: '#454545', logo: 'gl'},
                'el': { color: '#6f92bd', logo: 'gr'},
                'zh-hant': { color: '#454545', logo: 'hk'},
                'hr': { color: '#454545', logo: 'hr'},
                'hu': { color: '#454545', logo: 'hu'},
                'id': { color: '#9d5d69', logo: 'id'},
                'he': { color: '#454545', logo: 'il'},
                'hi': { color: '#93916f', logo: 'in'},
                'fa': { color: '#454545', logo: 'ir'},
                'is': { color: '#454545', logo: 'is'},
                'ja': { color: '#454545', logo: 'jp'},
                'sw': { color: '#454545', logo: 'ke'},
                'ky': { color: '#454545', logo: 'kg'},
                'km': { color: '#454545', logo: 'kh'},
                'ko': { color: '#454545', logo: 'kp'},
                'ko': { color: '#a09aa0', logo: 'kr'},
                'kk': { color: '#454545', logo: 'kz'},
                'lo': { color: '#454545', logo: 'la'},
                'si': { color: '#454545', logo: 'lk'},
                'lt': { color: '#454545', logo: 'lt'},
                'lb': { color: '#454545', logo: 'lu'},
                'lv': { color: '#454545', logo: 'lv'},
                'ro': { color: '#454545', logo: 'md'},
                'srp': { color: '#454545', logo: 'me'},
                'mg': { color: '#454545', logo: 'mg'},
                'mk': { color: '#454545', logo: 'mk'},
                'my': { color: '#454545', logo: 'mm'},
                'mn': { color: '#454545', logo: 'mn'},
                'zh-hant': { color: '#454545', logo: 'mo'},
                'ar': { color: '#3f5a24', logo: 'mr'},
                'mt': { color: '#454545', logo: 'mt'},
                'mfe': { color: '#454545', logo: 'mu'},
                'dv': { color: '#454545', logo: 'mv'},
                'ms': { color: '#454545', logo: 'my'},
                'nl': { color: '#75637f', logo: 'nl'},
                'nb': { color: '#454545', logo: 'no'},
                'ne': { color: '#454545', logo: 'np'},
                'na': { color: '#454545', logo: 'nr'},
                'niu': { color: '#454545', logo: 'nu'},
                'mi': { color: '#454545', logo: 'nz'},
                'pl': { color: '#b25d6d', logo: 'pl'},
                'ro': { color: '#454545', logo: 'ro'},
                'sr': { color: '#454545', logo: 'rs'},
                'ru': { color: '#65517b', logo: 'ru'},
                'rw': { color: '#454545', logo: 'rw'},
                'sv': { color: '#454545', logo: 'se'},
                'zh-hans': { color: '#454545', logo: 'sg'},
                'sl': { color: '#454545', logo: 'si'},
                'no': { color: '#454545', logo: 'sj'},
                'sk': { color: '#454545', logo: 'sk'},
                'it': { color: '#454545', logo: 'it'},
                'so': { color: '#454545', logo: 'so'},
                'th': { color: '#665a83', logo: 'th'},
                'tg': { color: '#454545', logo: 'tj'},
                'tkl': { color: '#454545', logo: 'tk'},
                'tk': { color: '#454545', logo: 'tm'},
                'tr': { color: '#ab0b28', logo: 'tr'},
                'zh-hant': { color: '#454545', logo: 'tw'},
                'sw': { color: '#454545', logo: 'tz'},
                'uk': { color: '#454545', logo: 'ua'},
                'uz': { color: '#454545', logo: 'uz'},
                'vi': { color: '#ac0e20', logo: 'vn'},
                'bi': { color: '#454545', logo: 'vu'},
                'sm': { color: '#454545', logo: 'ws'},
                // TODO chinese irish
            },
            LANGUAGE_CODES: {
                'ab': 'Abkhazian',
                'aa': 'Afar',
                'af': 'Afrikaans',
                'ak': 'Akan',
                'sq': 'Albanian',
                'am': 'Amharic',
                'ar': 'Arabic',
                'an': 'Aragonese',
                'hy': 'Armenian',
                'as': 'Assamese',
                'av': 'Avaric',
                'ae': 'Avestan',
                'ay': 'Aymara',
                'az': 'Azerbaijani',
                'bm': 'Bambara',
                'ba': 'Bashkir',
                'eu': 'Basque',
                'be': 'Belarusian',
                'bn': 'Bengali',
                'bh': 'Bihari',
                'bi': 'Bislama',
                'bs': 'Bosnian',
                'br': 'Breton',
                'bg': 'Bulgarian',
                'my': 'Burmese',
                'ca': 'Catalan',
                'ch': 'Chamorro',
                'ce': 'Chechen',
                'ny': 'Chichewa',
                'zh': 'Chinese',
                'cv': 'Chuvash',
                'kw': 'Cornish',
                'co': 'Corsican',
                'cr': 'Cree',
                'hr': 'Croatian',
                'cs': 'Czech',
                'da': 'Danish',
                'dv': 'Divehi',
                'nl': 'Dutch',
                'dz': 'Dzongkha',
                'en': 'English',
                'eo': 'Esperanto',
                'et': 'Estonian',
                'ee': 'Ewe',
                'fo': 'Faroese',
                'fj': 'Fijian',
                'fi': 'Finnish',
                'fr': 'French',
                'ff': 'Fulah',
                'gl': 'Galician',
                'ka': 'Georgian',
                'de': 'German',
                'el': 'Greek',
                'gn': 'Guarani',
                'gu': 'Gujarati',
                'ht': 'Haitian',
                'ha': 'Hausa',
                'he': 'Hebrew',
                'hz': 'Herero',
                'hi': 'Hindi',
                'ho': 'Hiri Motu',
                'hu': 'Hungarian',
                'ia': 'Interlingua',
                'id': 'Indonesian',
                'ie': 'Interlingue',
                'ga': 'Irish',
                'ig': 'Igbo',
                'ik': 'Inupiaq',
                'io': 'Ido',
                'is': 'Icelandic',
                'it': 'Italian',
                'iu': 'Inuktitut',
                'ja': 'Japanese',
                'jv': 'Javanese',
                'kl': 'Kalaallisut',
                'kn': 'Kannada',
                'kr': 'Kanuri',
                'ks': 'Kashmiri',
                'kk': 'Kazakh',
                'km': 'Central Khmer',
                'ki': 'Kikuyu',
                'rw': 'Kinyarwanda',
                'ky': 'Kirghiz',
                'kv': 'Komi',
                'kg': 'Kongo',
                'ko': 'Korean',
                'ku': 'Kurdish',
                'kj': 'Kuanyama',
                'la': 'Latin',
                'lb': 'Luxembourgish',
                'lg': 'Ganda',
                'li': 'Limburgan',
                'ln': 'Lingala',
                'lo': 'Lao',
                'lt': 'Lithuanian',
                'lu': 'Luba-Katanga',
                'lv': 'Latvian',
                'gv': 'Manx',
                'mk': 'Macedonian',
                'mg': 'Malagasy',
                'ms': 'Malay',
                'ml': 'Malayalam',
                'mt': 'Maltese',
                'mi': 'Maori',
                'mr': 'Marathi',
                'mh': 'Marshallese',
                'mn': 'Mongolian',
                'na': 'Nauru',
                'nv': 'Navajo',
                'nd': 'North Ndebele',
                'ne': 'Nepali',
                'ng': 'Ndonga',
                'nb': 'Norwegian Bokmål',
                'nn': 'Norwegian Nynorsk',
                'no': 'Norwegian',
                'ii': 'Sichuan Yi',
                'nr': 'South Ndebele',
                'oc': 'Occitan',
                'oj': 'Ojibwa',
                'cu': 'Church Slavic',
                'om': 'Oromo',
                'or': 'Oriya',
                'os': 'Ossetian',
                'pa': 'Punjabi',
                'pi': 'Pali',
                'fa': 'Persian',
                'pl': 'Polish',
                'ps': 'Pashto',
                'pt': 'Portuguese',
                'qu': 'Quechua',
                'rm': 'Romansh',
                'rn': 'Rundi',
                'ro': 'Romanian',
                'ru': 'Russian',
                'sa': 'Sanskrit',
                'sc': 'Sardinian',
                'sd': 'Sindhi',
                'se': 'Northern Sami',
                'sm': 'Samoan',
                'sg': 'Sango',
                'sr': 'Serbian',
                'gd': 'Gaelic',
                'sn': 'Shona',
                'si': 'Sinhala',
                'sk': 'Slovak',
                'sl': 'Slovenian',
                'so': 'Somali',
                'st': 'Southern Sotho',
                'es': 'Spanish',
                'su': 'Sundanese',
                'sw': 'Swahili',
                'ss': 'Swati',
                'sv': 'Swedish',
                'ta': 'Tamil',
                'te': 'Telugu',
                'tg': 'Tajik',
                'th': 'Thai',
                'ti': 'Tigrinya',
                'bo': 'Tibetan',
                'tk': 'Turkmen',
                'tl': 'Tagalog',
                'tn': 'Tswana',
                'to': 'Tonga',
                'tr': 'Turkish',
                'ts': 'Tsonga',
                'tt': 'Tatar',
                'tw': 'Twi',
                'ty': 'Tahitian',
                'ug': 'Uighur',
                'uk': 'Ukrainian',
                'ur': 'Urdu',
                'uz': 'Uzbek',
                've': 'Venda',
                'vi': 'Vietnamese',
                'vo': 'Volapük',
                'wa': 'Walloon',
                'cy': 'Welsh',
                'wo': 'Wolof',
                'fy': 'Western Frisian',
                'xh': 'Xhosa',
                'yi': 'Yiddish',
                'yo': 'Yoruba',
                'za': 'Zhuang',
                'zu': 'Zulu',
            },
            availableLanguages: [],
            allLanguages: [],
            tagColors: [
                { id: '1', color: '#617be3' },
                { id: '2', color: '#50d890' },
                { id: '3', color: '#ffa259' },
                { id: '4', color: '#fb5b5a' },
                { id: '5', color: '#f7be16' },
                { id: '6', color: '#7579e7' },
                { id: '7', color: '#fc7fb2' },
                { id: '8', color: '#555' },
            ]
        }
        
        window.CHART_COLORS = [
            // "#F44336",
            // "#E91E63",
            "#9C27B0",
            "#673AB7",
            "#3F51B5",
            "#2196F3",
            "#03A9F4",
            "#00BCD4",
            "#009688",
            "#4CAF50",
            "#8BC34A",
            "#CDDC39",
            "#FFEB3B",
            "#FFC107",
            "#FF9800",
            "#FF5722",
            "#795548",
            "#9E9E9E",
            "#607D8B",
            "#F44336",
            "#E91E63",
             // https://htmlcolorcodes.com/color-chart/
        ]

        window.heatmap = {
            blue: ["#EBF5FB", "#D6EAF8", "#AED6F1", "#85C1E9", "#5DADE2", "#3498DB", "#2E86C1", "#2874A6", "#21618C", "#1B4F72"],
            green: ["#DAF4DF", "#C6E8CD", "#AEDBB6", "#98CDA0", "#84C28F", "#64B272", "#4BA55D", "#309847", "#008A2E", "#007C11"],
            redyellow: ["#DBE700", "#E5D100", "#EAC11E", "#EFB12F", "#F49D3B", "#F88A46", "#FC794D", "#FF6655", "#FF515C", "#FF3B61"],
        }

        window.os = "web";

        Device.getInfo().then(async function(deviceInfo) {
            window.os = deviceInfo.platform;
            // Overwrite os for M1 Macs
            if (deviceInfo.name && deviceInfo.name.indexOf("Mac") !== -1) {
                window.os = "web"
            }
            document.documentElement.setAttribute("platform", window.os)
        })

        window.showSubscriptionModal = function(section) {
            Utilities.trackEvent("Subscription", "Subscription Modal Show", section)
            this.setState({ showSubscriptionModal: section })
        }.bind(this)

        window.hideSubscriptionModal = function() {
            Utilities.trackEvent("Subscription", "Subscription Modal Hide")
            this.setState({ showSubscriptionModal: false })
        }.bind(this)

        window.getChartColorI = function(i) {

            if (i === undefined) {
                return window.CHART_COLORS.concat(window.CHART_COLORS.concat(window.CHART_COLORS));
            }
            
            let length = window.CHART_COLORS.length;

            while (i > length) {
                i -= length;
            }

            if (!window.CHART_COLORS[i]) 
                return window.CHART_COLORS[0]

            return window.CHART_COLORS[i];
        
        }

        for (let key in window.globalVars.LANGUAGE_CODES) {
            window.globalVars.allLanguages.push(window.globalVars.LANGUAGE_CODES[key])
        }

    }

    async componentDidMount() {

        Utilities.trackEvent("State", "App Start");

        window.toast = function (text, type, id) {
            Utilities.trackEvent("Toast", "Toast Show", text, type === "info" ? 0 : type === "success" ? 1 : 2, true)
            if (type === "error")
                toast.error(text, {
                    toastId: id
                });
            if (type === "success")
                toast.success(text, {
                    toastId: id
                });
            if (type === "info" || !type)
                toast.info(text, {
                    toastId: id
                });
            setTimeout(() => {
                var toastOutside = document.querySelector("body>.Toastify");
                if (!toastOutside) {
                    var toastInside = document.querySelector(".Toastify");
                    if (toastInside)
                        document.body.appendChild(toastInside);  
                }   
            }, 300);  
        }

        if (localStorage.getItem("reloadOnInit")) {
            window.toast(window.ln.syncEnabled, "success");
            setTimeout(() => {
                localStorage.removeItem("reloadOnInit")
                localStorage.setItem("preventAppOpenTrack", "true")
                window.location.reload();
            }, 1500)
            return;
        }

        App.addListener('appUrlOpen', (event) => {
            Utilities.trackEvent("State", "App Open from Link", event.url)
            if (event && event.url) {
                if (event.url.indexOf("/set/") !== -1) {
                    localStorage.setItem("preventAppOpenTrack", "true")
                    window.location.href = "/set/" + event.url.split("/set/")[1]
                } else if (event.url.indexOf("/dropbox/") !== -1) {
                    localStorage.setItem("preventAppOpenTrack", "true")
                    window.location.href = "/dropbox/" + event.url.split("/dropbox/")[1] + "/" + event.url.split("/dropbox/")[2]
                } else if (event.url.indexOf("/import") !== -1) {
                    localStorage.setItem("preventAppOpenTrack", "true")
                    window.location.href = "/import/";
                } 
            }
        });

        setTimeout( async () => {
            // TO DO Ocasional reload
            window.cardsGrouppedByLang = await SQLStorage.getAllCardsGrouppedByLang();
            // let cards = await SQLStorage.getAllCardsLastReviewed();
            // console.log("LAST REVIEWED", cards)
        }, 4000)

        SplashScreen.hide();

        window.PRC = PRC;

        this.loadAvailableVoices();

        this.init();

        store.dispatch(updateURL(window.location.pathname))

        setInterval(function() {
            if (window.location.pathname !== this.state.currentUrl) {
                Utilities.trackPageview();
                window.prevUrl = this.state.currentUrl;
                window.currentUrl = window.location.pathname
                this.setState({ currentUrl: window.location.pathname })
                store.dispatch(updateURL(window.location.pathname))
                if (window.location.pathname.indexOf("/sets") !== -1) { 
                    if (!localStorage.getItem("consolidateStorage")) {
                        window.dropbox.startSync();
                    }
                }
                let el = document.getElementsByTagName("body");
                if (el && el[0]) el[0].setAttribute("data-page", window.location.pathname);
                if (!window.location.pathname.startsWith("/discover") && !window.location.pathname.startsWith("/set/")) {
                    Utilities.writeDefaultMetaTags();
                }
            }
        }.bind(this), 100);

        setTimeout(async function() {
            this.setState({ os: window.os })
            this.reloadNotifications();
            window.removeEventListener("focus", this.reloadNotifications.bind(this));
            window.addEventListener("focus", this.reloadNotifications.bind(this));
            window.removeEventListener("blur", this.onBlur.bind(this));
            window.addEventListener("blur", this.onBlur.bind(this));
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                window.dark = true;
            }
        }.bind(this), 300)

        if (!localStorage.getItem("trendingCache")) {
            localStorage.setItem("trendingCache", JSON.stringify(TrendingBase));
        }

        const trendingTimeout = Utilities.dateAdd(new Date(localStorage.getItem("trendingCacheLastUpdated") || ""), "day", 1);
        if (!localStorage.getItem("trendingCacheLastUpdated") || (trendingTimeout < new Date())) {
            let res = await Server.getTrendingPublicSets("", "");
            if (res && res.sets) {
                localStorage.setItem("trendingCacheLastUpdated", new Date().toString())
                localStorage.setItem("trendingCache", JSON.stringify(res))
            }
        }

        if (!window.location.pathname.startsWith("/discover") && !window.location.pathname.startsWith("/set/")) {
            Utilities.writeDefaultMetaTags();
        }

        window.onPronounceMuteAlert = function() {
            window.onPronounceMuteAlertIgnoredThisSession = true;
            this.setState({ pronounceMuteAlert: true })
        }.bind(this)
    }

    async showDropboxTokenEntryIfNeeded() {
        if (localStorage.getItem("externalAuthStarted")) {
            this.setState({
                showManualDropboxTokenEntry: true
            })
        }
    }
    
    async onBlur() {
        Utilities.trackEvent("State", "Blur");
    }

    async reloadNotifications() {

        Utilities.trackEvent("State", "Focus");

        this.showDropboxTokenEntryIfNeeded();

        if (localStorage.getItem("externalAuthStarted")) {
            return;
        }

        if (!window.db) {
            return;
        }

        let settings = await SQLStorage.getSettingsObj();

        if (settings && settings.dailyCatchUpTime && settings.dailyCatchUpTime !== "Off") {

            let permissionState = await LocalNotifications.checkPermissions();

            if (permissionState.display === "denied") {
                // window.toast("Notifications were disabled, enable in settings", "error");
                return
            } else if (permissionState.display === "granted") {
            } else {
                permissionState = await LocalNotifications.requestPermissions();
                // this.ionViewDidEnter();
                // return;
            }

            await Utilities.cancelPendingCatchupNotifications();

            let now = new Date();
            now.setHours(parseInt(settings.dailyCatchUpTime.substr(0, 2)));
            now.setMinutes(0);
            now.setSeconds(0)

            let until = Utilities.dateAdd(now, "week", 1);
            let lastId = 101
            let notificationsToBeScheduled = [];

            let newCards = await SQLStorage.getNewCardsCount();
            let strengthCardsCount = await SQLStorage.getStrengthCardsCount();

            while (now < until) {

                let dueCards = await SQLStorage.getDueCardsCount(Math.round(Utilities.getTimestamp(now)));
                let body = window.ln.notificationDailyCatchUpBody
                    .replace("__", newCards)
                    .replace("___", dueCards)
                    .replace("____", strengthCardsCount['1'])
                    .replace("_____", strengthCardsCount['3'])
                    .replace("______", strengthCardsCount['5']);

                // console.log("===== SCHEDLING FOR " + now + " " + body);

                if (now > new Date()) {
                    notificationsToBeScheduled.push({
                        title: window.ln.notificationDailyCatchUpTitle,
                        body: body,
                        id: lastId,
                        schedule: { at: now },
                        sound: "default",
                        attachments: null,
                        actionTypeId: "",
                        extra: null
                    })
                }

                now = Utilities.dateAdd(now, "day", 1);
                lastId++;

            }

            await LocalNotifications.schedule({ notifications: notificationsToBeScheduled });
        
        }
    }

    async init() {

        console.log("init()")

        let deviceInfo = await Device.getInfo();

        // Make it fail 5 times - as it randomly switched to indexed db because of an exception
        if (localStorage.getItem("indexedDbFallback5")) {
            window.useIndexedDb = true;
        }

        // TO DO consider upgrading everyone to indexed db on new init

        if (window.useIndexedDb) {

            try {
                const db = new Dexie("simplecards");

                db.version(1).stores({
                    cards: 'id,createdAt,term,definition,setId,image,strength,lastReviewed,reviewCount,reviewAfter,deleted,customInt1,links,customText2,[setId+customInt1],[strength+customInt1],[reviewAfter+customInt1],[reviewCount+strength]',
                    sets: 'id,viewSecret',
                    tags: 'id',
                    tagIndexes: '[setId+cardId+tagId],cardId', // setId,,tagId',
                    settingss: 'key',
                    batchContent: '[batchTimestamp+cardId]' // ,batchTimestamp,cardId'
                    // cachedImages: 'cardId,fileName',
                    // cachedRecordings: 'cardId,fileName',
                });
    
                window.db = db;
            } catch (e) {
                if (window.location.pathname.indexOf("/terms") === -1 && window.location.pathname.indexOf("/flashcards") === -1 && window.location.pathname.indexOf("/practice") === -1 && window.location.pathname.indexOf("/unsupported-browser") === -1 && window.location.pathname.indexOf("/dropbox") === -1 && window.location.pathname.indexOf("/set") === -1) {
                    // localStorage.setItem("preventAppOpenTrack", "true")
                    // window.location.href = "/unsupported-browser"
                } 
                return;
            }

        } else if (window.sqlitePlugin) {
            try {
                window.db = window.sqlitePlugin.openDatabase({name: 'SimpleCards2.db', location: 'default', androidDatabaseProvider: 'system'});
            } catch (e) {
                if (!localStorage.getItem("indexedDbFallback")) {
                    localStorage.setItem("indexedDbFallback", "true");
                } else if (!localStorage.getItem("indexedDbFallback2")) {
                    localStorage.setItem("indexedDbFallback2", "true");
                } else if (!localStorage.getItem("indexedDbFallback3")) {
                    localStorage.setItem("indexedDbFallback3", "true");
                } else if (!localStorage.getItem("indexedDbFallback4")) {
                    localStorage.setItem("indexedDbFallback4", "true");
                } else if (!localStorage.getItem("indexedDbFallback5")) {
                    localStorage.setItem("indexedDbFallback5", "true");
                }
                localStorage.setItem("preventAppOpenTrack", "true")
                setTimeout(() => {
                    window.location.reload();
                }, 250)
                // TO DO restore
                if (window.location.pathname.indexOf("/terms") === -1 && window.location.pathname.indexOf("/flashcards") === -1 && window.location.pathname.indexOf("/practice") === -1 && window.location.pathname.indexOf("/unsupported-browser") === -1 && window.location.pathname.indexOf("/dropbox") === -1 && window.location.pathname.indexOf("/set") === -1) {
                    // localStorage.setItem("preventAppOpenTrack", "true")
                    // window.location.href = "/unsupported-browser"
                } 
                return;
            }
            localStorage.removeItem("indexedDbFallback");
            localStorage.removeItem("indexedDbFallback2");
            localStorage.removeItem("indexedDbFallback3");
            localStorage.removeItem("indexedDbFallback4");
            localStorage.removeItem("indexedDbFallback5");
        } else {
            try {
                window.db = window.openDatabase('SimpleCards2', '1.0', 'Data', 50*1024*1024);
            } catch (e) {
                if (!localStorage.getItem("indexedDbFallback")) {
                    localStorage.setItem("indexedDbFallback", "true");
                } else if (!localStorage.getItem("indexedDbFallback2")) {
                    localStorage.setItem("indexedDbFallback2", "true");
                } else if (!localStorage.getItem("indexedDbFallback3")) {
                    localStorage.setItem("indexedDbFallback3", "true");
                } else if (!localStorage.getItem("indexedDbFallback4")) {
                    localStorage.setItem("indexedDbFallback4", "true");
                } else if (!localStorage.getItem("indexedDbFallback5")) {
                    localStorage.setItem("indexedDbFallback5", "true");
                }
                localStorage.setItem("preventAppOpenTrack", "true")
                setTimeout(() => {
                    window.location.reload();
                }, 250)
                // TO DO restore
                if (window.location.pathname.indexOf("/terms") === -1 && window.location.pathname.indexOf("/flashcards") === -1 && window.location.pathname.indexOf("/practice") === -1 && window.location.pathname.indexOf("/unsupported-browser") === -1 && window.location.pathname.indexOf("/dropbox") === -1 && window.location.pathname.indexOf("/set") === -1) {
                    // localStorage.setItem("preventAppOpenTrack", "true")
                    // window.location.href = "/unsupported-browser"
                } 
                return;
            }
            localStorage.removeItem("indexedDbFallback");
            localStorage.removeItem("indexedDbFallback2");
            localStorage.removeItem("indexedDbFallback3");
            localStorage.removeItem("indexedDbFallback4");
            localStorage.removeItem("indexedDbFallback5");
        }

        let settings = await Storage.getO("settings");
        let sqlSettings = await SQLStorage.getSettingsObj();
        sqlSettings.imgOfflineSets = sqlSettings.imgOfflineSets || [];
        window.settings = sqlSettings;
        if (window.settings && window.settings.account) {
            window.settings.account = JSON.parse(window.settings.account);
        }
        window.settings2 = settings;

        if (sqlSettings && sqlSettings.lang) {
            if (sqlSettings.lang === "hu") { window.ln = huLang; }
            else if (sqlSettings.lang === "es") { window.ln = esLang; }
            else if (sqlSettings.lang === "pt") { window.ln = ptLang; }
            else if (sqlSettings.lang === "da") { window.ln = daLang; }
            else if (sqlSettings.lang === "de") { window.ln = deLang; }
            else if (sqlSettings.lang === "et") { window.ln = etLang; }
            else if (sqlSettings.lang === "fi") { window.ln = fiLang; }
            else if (sqlSettings.lang === "fr") { window.ln = frLang; }
            else if (sqlSettings.lang === "it") { window.ln = itLang; }
            else if (sqlSettings.lang === "nl") { window.ln = nlLang; }
            else if (sqlSettings.lang === "no") { window.ln = noLang; }
            else if (sqlSettings.lang === "pl") { window.ln = plLang; }
            else if (sqlSettings.lang === "ro") { window.ln = roLang; }
            else if (sqlSettings.lang === "sk") { window.ln = skLang; }
            else if (sqlSettings.lang === "sl") { window.ln = slLang; }
            else if (sqlSettings.lang === "sv") { window.ln = svLang; }
        }

        if (window.ln) {
            window.levels = [
                { xp: 500, name: window.ln.levelSilver.replace("__", 1), level: 1, material: 1 },
                { xp: 1000, name: window.ln.levelSilver.replace("__", 2), level: 2, material: 1 },
                { xp: 2000, name: window.ln.levelSilver.replace("__", 3), level: 3, material: 1 },
                { xp: 4000, name: window.ln.levelSilver.replace("__", 4), level: 4, material: 1 },
    
                { xp: 6000, name: window.ln.levelGold.replace("__", 1), level: 1, material: 2 },
                { xp: 8000, name: window.ln.levelGold.replace("__", 2), level: 2, material: 2 },
                { xp: 10000, name: window.ln.levelGold.replace("__", 3), level: 3, material: 2 },
                { xp: 12000, name: window.ln.levelGold.replace("__", 4), level: 4, material: 2 },
    
                { xp: 16000, name: window.ln.levelPlatinum.replace("__", 1), level: 1, material: 3 },
                { xp: 20000, name: window.ln.levelPlatinum.replace("__", 2), level: 2, material: 3 },
                { xp: 24000, name: window.ln.levelPlatinum.replace("__", 3), level: 3, material: 3 },
                { xp: 28000, name: window.ln.levelPlatinum.replace("__", 4), level: 4, material: 3 },
    
                { xp: 32000, name: window.ln.levelDiamond.replace("__", 1), level: 1, material: 4 },
                { xp: 38000, name: window.ln.levelDiamond.replace("__", 2), level: 2, material: 4 },
                { xp: 44000, name: window.ln.levelDiamond.replace("__", 3), level: 3, material: 4 },
                { xp: 50000, name: window.ln.levelDiamond.replace("__", 4), level: 4, material: 4 },
    
                { xp: 60000, name: window.ln.levelJade.replace("__", 1), level: 1, material: 5 },
                { xp: 70000, name: window.ln.levelJade.replace("__", 2), level: 2, material: 5 },
                { xp: 80000, name: window.ln.levelJade.replace("__", 3), level: 3, material: 5 },
                { xp: 100000, name: window.ln.levelJade.replace("__", 4), level: 4, material: 5 },
            ]
        }

        window.FONT_SIZES = [null, window.ln.verySmall, window.ln.small, window.ln.normal, window.ln.big, window.ln.veryBig]

        window.initDropbox = async function() {
            const settings = await Storage.getO("settings");
            if (settings.dropbox) {
                console.log("____- initing dropbox with " + settings.dropbox.key)
                const DropboxSDK = require('dropbox').Dropbox;
                window.dropbox.api = new DropboxSDK({ accessToken: settings.dropbox.key });
                if (localStorage.getItem("consolidateStorage")) {
                    window.dropbox.consolidateStorage();
                } else {
                    window.dropbox.startSync();
                }
            }
        }

        if (!settings) {

            await Storage.setO("settings", { dropbox: null })
            await Storage.setO("upQueue", [])
            await Storage.setO("downQueue", [])
            let deviceInfoStr = "";

            for (let key in deviceInfo) {
                if (deviceInfo[key])
                    deviceInfoStr += key + ": " + deviceInfo[key] + ", ";
            }

            Utilities.slack(deviceInfoStr);

            const SPACED_REPETITION = [
                { hours: 24 }, // 1 day -> 1st day
                { hours: 48 }, // 2 days -> 3rd day
                { hours: 96, learnt: true }, // 4 days -> 7th day
                { hours: 192 }, // 8 days -> 15th day
                { hours: 384, mastered: true } // 16 days -> 31st day
            ]

            if (window.useIndexedDb) {

                await window.db.settingss.bulkPut([
                    {key: "spacedRepetitionCycles", value: JSON.stringify(SPACED_REPETITION)},
                ]);
    
                await window.db.tags.bulkPut([
                    {id: "star", createdAt: null, updatedAt: null, name: "star", color: "5"},
                    {id: "learnt", createdAt: null, updatedAt: null, name: "learnt", color: "1"},
                    {id: "new", createdAt: null, updatedAt: null, name: "new", color: "3"},
                    {id: "mastered", createdAt: null, updatedAt: null, name: "mastered", color: "6"},
                    {id: "studying", createdAt: null, updatedAt: null, name: "studying", color: "2"},
                    {id: "image", createdAt: null, updatedAt: null, name: "image", color: "6"},
                    {id: "recording", createdAt: null, updatedAt: null, name: "recording", color: "7"}
                ]);
    
            } else {
                window.db.transaction(function(tx) {
                    tx.executeSql(`CREATE TABLE IF NOT EXISTS Cards (id Text, createdAt Text, updatedAt Text, updatedAtTimestamp Integer,term Text, definition Text, tags Text, setId Text, star Text, image Text, recording Text, history Text, strength Integer,strengthUpdatedAt Integer,tagUpdatedAt Integer,starUpdatedAt Integer,lastReviewed Integer,reviewCount Integer,mistakeLastMade Integer,mistakeCount Integer,successLastMade Integer,successCount Integer,reviewAfter Integer,revisionCycle Integer,deleted Text,customText1 Text,customText2 Text, customInt1 Integer,customInt2 Integer,links Text)`);
                    tx.executeSql('CREATE TABLE IF NOT EXISTS Sets (id Text, createdAt Text, updatedAt Text, name Text, term Text, definition Text, color Text, icon Text, customText1 Text, customText2 Text, customText3 Text, viewSecret Text, editSecret Text, lastPushed Text, lastFetched Text, shareMode Text, owner Text, description Text, tags Text, ownerUsername Text, ownerImageUrl Text)');
                    tx.executeSql('CREATE TABLE IF NOT EXISTS Tags (id Text, createdAt Text, updatedAt Text, name Text, color Text, icon Text, customText1 Text, customText2 Text, customText3 Text)');
                    tx.executeSql('CREATE TABLE IF NOT EXISTS TagIndexes (setId Text, cardId Text, tagId Text)');
                    tx.executeSql('CREATE TABLE IF NOT EXISTS Settings (key Text, value Text)');
                    tx.executeSql('CREATE TABLE IF NOT EXISTS CachedImages (cardId Text, fileName Text)');
                    tx.executeSql('CREATE TABLE IF NOT EXISTS CachedRecordings (cardId Text, fileName Text)');
                    tx.executeSql('CREATE TABLE IF NOT EXISTS BatchContent (batchTimestamp Integer, cardId Text)');
                    tx.executeSql('INSERT INTO Settings (key, value) VALUES (?, ?)', ["spacedRepetitionCycles", JSON.stringify(SPACED_REPETITION)]);
                    tx.executeSql('INSERT INTO Tags (id,createdAt,updatedAt,name,color) VALUES (?,?,?,?,?)', ["star", null, null, "star", "5"]);
                    tx.executeSql('INSERT INTO Tags (id,createdAt,updatedAt,name,color) VALUES (?,?,?,?,?)', ["learnt", null, null, "learnt", '1']);
                    tx.executeSql('INSERT INTO Tags (id,createdAt,updatedAt,name,color) VALUES (?,?,?,?,?)', ["new", null, null, "new", '3']);
                    tx.executeSql('INSERT INTO Tags (id,createdAt,updatedAt,name,color) VALUES (?,?,?,?,?)', ["mastered", null, null, "mastered", '6']);
                    tx.executeSql('INSERT INTO Tags (id,createdAt,updatedAt,name,color) VALUES (?,?,?,?,?)', ["studying", null, null, "studying", '2']);
                    tx.executeSql('INSERT INTO Tags (id,createdAt,updatedAt,name,color) VALUES (?,?,?,?,?)', ["image", null, null, "image", '6']);
                    tx.executeSql('INSERT INTO Tags (id,createdAt,updatedAt,name,color) VALUES (?,?,?,?,?)', ["recording", null, null, "recording", '7']);
                }, function(e) { console.log("ERROR", e) })
    
                localStorage.setItem("sql-schema-update-1", "true");
                localStorage.setItem("sql-schema-update-2", "true");
            }

        } else {

            if (!window.useIndexedDb) {
                if (!localStorage.getItem("sql-schema-update-1")) {
                    window.db.transaction(function(tx) {
                        tx.executeSql('ALTER TABLE Cards ADD COLUMN links Text');
                    }, function(e) { console.log("ERROR", e) })
                    localStorage.setItem("sql-schema-update-1", "true")
                }
    
                if (!localStorage.getItem("sql-schema-update-2")) {
                    setTimeout(() => {
                        window.db.transaction(function(tx) {
                            tx.executeSql('ALTER TABLE Sets ADD COLUMN viewSecret Text');
                            tx.executeSql('ALTER TABLE Sets ADD COLUMN editSecret Text');
                            tx.executeSql('ALTER TABLE Sets ADD COLUMN lastPushed Text');
                            tx.executeSql('ALTER TABLE Sets ADD COLUMN lastFetched Text');
                            tx.executeSql('ALTER TABLE Sets ADD COLUMN shareMode Text');
                            tx.executeSql('ALTER TABLE Sets ADD COLUMN owner Text');
                        }, function(e) { console.log("ERROR", e) })
                        localStorage.setItem("sql-schema-update-2", "true")
                    }, 2000)
                }

                if (!localStorage.getItem("sql-schema-update-3")) {
                    setTimeout(() => {
                        window.db.transaction(function(tx) {
                            tx.executeSql('ALTER TABLE Sets ADD COLUMN description Text');
                            tx.executeSql('ALTER TABLE Sets ADD COLUMN ownerUsername Text');
                            tx.executeSql('ALTER TABLE Sets ADD COLUMN ownerImageUrl Text');
                            tx.executeSql('ALTER TABLE Sets ADD COLUMN tags Text');
                        }, function(e) { console.log("ERROR", e) })
                        localStorage.setItem("sql-schema-update-3", "true")
                    }, 2000)
                }
            }

            window.initDropbox();

        }

        window.loadTagRefCountsForSets = async function() {
            let tagReferences = await SQLStorage.getTagReferences();
            let tagReferencesBySet = {}

            tagReferences = tagReferences || [];
            tagReferences.map(item => {
                if (!tagReferencesBySet[item.setId])
                    tagReferencesBySet[item.setId] = [];
                tagReferencesBySet[item.setId].push(item);
            })

            store.dispatch(updateSets({
                tagReferencesBySet: tagReferencesBySet
            }))
        }

        window.startDropboxAuth = async function() {
            localStorage.setItem("externalAuthStarted", "true");

            if (isPlatform("ios") || isPlatform("android")) {
                window.open(window.domainPathAuth + 'auth-db.html');
            } else {
                window.location.href = window.domainPathAuth + 'auth-db.html';
            }

            this.showDropboxTokenEntryIfNeeded()
        }.bind(this)

        window.loadInitStudysets = async function(prevState, firstInit) {

            console.time('@@@@@ loadInitStudysets()');
            
            SQLStorage.getDueCardsCount(Math.round(Utilities.timestamp())).then(dueCards => {
                store.dispatch(updateSets({ dueCards: dueCards }));
            })

            SQLStorage.getNewCardsCount(Math.round(Utilities.timestamp())).then(newCards => {
                store.dispatch(updateSets({ newCards: newCards }));
            })

            SQLStorage.getStrengthCardsCount(Math.round(Utilities.timestamp())).then(strengthCardsCount => {
                store.dispatch(updateSets({
                    masteredCards: strengthCardsCount['5'],
                    studyingCards: strengthCardsCount['1'],
                    learntCards: strengthCardsCount['3'],
                }));
            })

            let upQueue = await Storage.getO("upQueue");
            let downQueue = await Storage.getO("downQueue");
            let lastPractice = await Storage.getO("lastPractice");
            let studysets = await SQLStorage.getStudysets();
            let settings = await SQLStorage.getSettingsObj();
            let tags = await SQLStorage.getTags();

            let studysetsObj = {}
            let nothingLeft = (upQueue && downQueue && upQueue.length === 0 && downQueue.length === 0);
    
            studysets = studysets || [];
            let studysetsFormattedArr = studysets.map(item => {
                let isSyncing = false;
                if (prevState) {
                    let lastStateStudyset = prevState.filter(prevItem => prevItem.id === item.id)[0];
                    if (lastStateStudyset) {
                        isSyncing = lastStateStudyset.isSyncing
                    }
                }
                if (nothingLeft) {
                    isSyncing = false;
                }
                item.updatedAt = Utilities.iOSFixDate(item.updatedAt);
                item.count = item.cardNo || 0;
                item.isSyncing = isSyncing;
                studysetsObj[item.id] = item;
                return item;
            })
    
            store.dispatch(updateSets({
                tags: tags,
                studysetsFormatted: studysetsFormattedArr,
                studysets: studysetsObj,
                lastPractice: lastPractice,
                settings: settings,
            }))

            lastPractice = (lastPractice && lastPractice.type) ? lastPractice : null;

            if (lastPractice && firstInit) {
                setTimeout(function() {
                    if (document.getElementById("continue-last-pracitce-btn")) { document.getElementById("continue-last-pracitce-btn").click(); }
                    else {
                        setTimeout(function() {
                            if (document.getElementById("continue-last-pracitce-btn")) { document.getElementById("continue-last-pracitce-btn").click(); }
                            else {
                                setTimeout(function() {
                                    if (document.getElementById("continue-last-pracitce-btn")) { document.getElementById("continue-last-pracitce-btn").click(); }
                                }, 300)
                            }
                        }, 300)   
                    }
                }, 300)
            }

            window.loadTagRefCountsForSets();
    
        }

        window.loadInitStudysets(null, true);

        window.activationCheck = async function() {

            window.debugging = localStorage.getItem("debug") ? true : false;

            window.activated = false;

            let licence = await SQLStorage.getSetting("licence");
            let account = await SQLStorage.getSetting("account");
    
            if (licence) {
                // console.log("@@@@@@@ Activated inapp");
                window.activated = true;
            }
            
            if (account) {

                account = JSON.parse(account);

                if (account.activeSubscriptions && account.activeSubscriptions.indexOf("com.dominikgyecsek.simplecards") !== -1) {
                    window.activated = true;
                    window.activatedViaAccount = true;
                }

                const newUser = await Server.logIn(account.email, account.password).catch(e => { console.log("Error logging in", e) });

                if (newUser) {

                    if (newUser.activeSubscriptions && newUser.activeSubscriptions.indexOf("com.dominikgyecsek.simplecards") !== -1) {
                        window.activated = true;
                        window.activatedViaAccount = true;
                    }

                    await SQLStorage.saveSetting("account", {
                        ...newUser,
                        id: newUser._id,
                    });
                }
            }

            if (!window.activated) {

                let promo = localStorage.getItem("promoCode");

                if (promo) {
                    let validUntil = PRC[promo];
                    let now = new Date();
                    
                    if (validUntil > now) {
                        // console.log("Activated with promo");
                        window.activated = true;
                    } else {
                        window.toast("Your previous promo code has expired, you can enter a new one in settings.", "error")
                        localStorage.removeItem("promoCode");
                    }
                }

            }

            if (!window.activated) {
                
                let promo = window.settings.promocode ? JSON.parse(window.settings.promocode) : {};
                if (promo && promo.validUntil) {
                    promo.validUntil = new Date(promo.validUntil*1000) // Utilities.dateSub(new Date(promo.validUntil*1000), "day", 5)
                    if ((new Date()) > promo.validUntil) {
                        window.toast("Your previous promo code has expired, you can enter a new one in settings.", "error")
                        await SQLStorage.saveSetting("promocode", "");
                        await window.dropbox.queueForUpload("setting", "promocode");
                        store.dispatch(updatedSetsSet(['null']))
                        window.dropbox.debounce(true);
                    } else {
                        // console.log("Activated with promo 2");
                        window.activated = true;
                    }
                }
            }
        }
        
        window.activationCheck();

        let notchSetIntervalI = 0;
        let notchSetInterval = setInterval(function() {
            window.notchSizeBottom = parseInt(getComputedStyle(window.document.documentElement).getPropertyValue("--ion-safe-area-bottom").replace("px", ""));
            window.notchSizeTop = parseInt(getComputedStyle(window.document.documentElement).getPropertyValue("--ion-safe-area-top").replace("px", ""));
            notchSetIntervalI++;
            if (notchSetIntervalI === 10) {
                clearInterval(notchSetInterval)
            }
        }.bind(this), 100);

        store.subscribe(() => {
            const state = store.getState();
            if (state && state.updatedSets && state.updatedSets.length !== 0 && state.url.indexOf("/sets") !== -1 && (!window.prevUrl || window.prevUrl.indexOf("sets") === -1)) {
                window.loadInitStudysets(state.calendar.studysetsFormatted);
                store.dispatch(clearUpdatedSetsSet());
            }
        });

        Keyboard.setResizeMode({mode:"body"})

        window.inited = true;

        const deletedUnSettedCards = await SQLStorage.getAndDeleteCardsWithoutSets();
        if (deletedUnSettedCards) {
            window.loadInitStudysets();
        }

    }

    async loadAvailableVoices() {
        if (!window.supportedLanguages) {
            window.supportedLanguages = await TextToSpeech.getSupportedLanguages();

            if (window.supportedLanguages) { 
                window.supportedLanguages = [...new Set(window.supportedLanguages.languages.map(l => l.substring(0, 2)))]
            }
        }
    }

    render() {

        return (
            <IonApp data-page={this.state.currentUrl} data-os={this.state.os}>
            <IonReactRouter>
                <IonTabs>
                    <IonRouterOutlet>
                        <Route path="/" render={() => <Redirect to="/sets" />} exact={true} />
                        <Route path="/set/:id" component={Studyset} />
                        <Route path="/dropbox/:accessToken/:refreshToken" component={DropboxInit} />
                        <Route path="/queue" component={Queue} />
                        <Route path="/sets" component={Studysets} />
                        <Route path="/studyset/:id" component={Studyset} />
                        <Route path="/studyset/:id/justcreated" component={Studyset} />
                        <Route path="/flashcards" component={Flashcards} />
                        <Route path="/practice/" component={Practice} exact={true} />
                        <Route path="/help/:slug" component={HelpGuide} exact={true} />
                        <Route path="/help" component={HelpGuides} exact={true} />
                        <Route path="/discover/:category" component={Discover} exact={true} />
                        <Route path="/discover" component={Discover} exact={true} />
                        <Route path="/allsets" component={AllSets} exact={true} />
                        <Route path="/settings" component={Settings} />
                        <Route path="/stats" component={Statistics} />
                        <Route path="/import" component={Import} />
                        <Route path="/terms" component={Terms} />
                        <Route path="/subscription" component={Subscription} />
                        <Route path="/unsupported-browser" component={UnsupportedBrowser} />
                    </IonRouterOutlet>
                    <IonTabBar slot="bottom">
                        <IonTabButton tab="tab1" href="/sets">
                            <IonIcon style={{ fontSize: '2.6em' }} icon={folder} mode="ios" />
                            <IonLabel>{window.ln.sets}</IonLabel>
                        </IonTabButton>
                        <IonTabButton tab="tab2" href="/stats">
                            <IonIcon style={{ fontSize: '2.6em' }} icon={statsChart} mode="ios" />
                            <IonLabel>{window.ln.stats}</IonLabel>
                        </IonTabButton>
                        <IonTabButton tab="tab4" href="/help">
                            <IonIcon style={{ fontSize: '2.6em' }} icon={helpBuoy} mode="ios" />
                            <IonLabel>{window.ln.guides}</IonLabel>
                        </IonTabButton>
                        <IonTabButton tab="tab3" href="/discover">
                            <IonIcon style={{ fontSize: '2.6em' }} icon={earth} mode="ios" />
                            <IonLabel>{window.ln.discover}</IonLabel>
                        </IonTabButton>
                        <IonTabButton tab="tab5" href="/settings">
                            <IonIcon style={{ fontSize: '2.6em' }} icon={settings} mode="ios" />
                            <IonLabel>{window.ln.settings}</IonLabel>
                        </IonTabButton>
                    </IonTabBar>
                </IonTabs>
            </IonReactRouter>
                <ToastContainer
                    position="top-right"
                    autoClose={4000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss={false}
                    draggable={false}
                    pauseOnHover={false}
                    theme={'colored'}
                />
                { this.state.showSubscriptionModal &&
                    <Subscription 
                        modal={this.state.showSubscriptionModal}
                        onClose={() => {
                            window.hideSubscriptionModal();
                        }}
                    />
                }
                <IonAlert
                    isOpen={this.state.showManualDropboxTokenEntry}
                    onDidDismiss={() => {
                        localStorage.removeItem("externalAuthStarted");
                        this.setState({ showManualDropboxTokenEntry: null })
                    }}
                    cssClass='my-custom-class'
                    header={"Enter Code from Dropbox"}
                    inputs={[
                        {
                            name: 'code',
                            placeholder: "Code",
                            type: 'string',
                            value: ''
                        },
                    ]}
                    buttons={[
                        {
                            text: window.ln.cancel,
                            role: 'cancel',
                            cssClass: 'secondary',
                            handler: () => { }
                        },
                        {
                            text: window.ln.startSync,
                            handler: async (e) => {
                                let settings = await Storage.getO("settings");
                                settings.dropbox = (settings.dropbox && settings.dropbox.key) ? settings.dropbox : { };
                                settings.dropbox.key = "sl.BFS9GSYngbd6uDRBwvJYW5mL5SkvGy3xDmbH3SfSQcPhrzk7a_ZdwfgAWBGEauVUFQllZKAfEUi50ypIU8upifrYytTIbsFPmySk5EslTsAFTAC3nyPdBU3S6FwxNEfZFGMXSMX9";
                                settings.dropbox.refreshToken = e.code;

                                localStorage.removeItem("externalAuthStarted");
                                await Storage.setO("settings", settings);
                                localStorage.setItem("reloadOnInit", "true");
                                localStorage.setItem("preventAppOpenTrack", "true")
                                window.location.href = "/sets";
                            }
                        }
                    ]}
                />
                <IonAlert
                    isOpen={this.state.pronounceMuteAlert}
                    onDidDismiss={() => { this.setState({ pronounceMuteAlert: null }) }}
                    header={"Please note that pronunciations might only work when your phone is not muted depending on your devices."}
                    buttons={[
                        {
                            text: window.ln.dontShowAgain || "Don't Show Again",
                            handler: () => {
                                localStorage.setItem("ignoreMutedPronounceWarning", "true");
                                this.setState({ pronounceMuteAlert: false })
                            }
                        },
                        {
                            text: window.ln.close,
                        }
                    ]}
                />
            </IonApp>
        )
    }

};

export default AppMain;
